<template>
  <FormSection title="Módulos e integrações" class="boletos-modulo">
    <div class="modulo-conteudo">
    <h6>Módulo de Boletos</h6>
    <p>Permite emitir e gerenciar boletos nesta escola. A utilização também depende das configurações das contas financeiras.</p>
    <p role="status" aria-live="polite">
      Estado atual: <strong>{{ busy ? 'Confirmando com o servidor…' : estado === true ? 'Ativado' : estado === false ? 'Desativado' : 'Não confirmado' }}</strong>
    </p>
    <div v-if="erro" class="alert alert-danger" role="alert">{{ erro }}</div>
    <div v-if="sucesso" class="alert alert-success" role="status">{{ sucesso }}</div>
    <p v-if="!podeAlterarModulo" class="text-muted">Esta habilitação pode ser alterada por superadministradores ou administradores desta escola com a permissão de configurar cobranças.</p>
    <div class="d-flex gap-2 flex-wrap">
      <button v-if="podeAlterarModulo" type="button" class="btn btn-sm btn-outline-primary" :disabled="busy || estado === null || alvo !== null" @click="solicitar">
        {{ estado === true ? 'Desativar módulo de boletos' : 'Ativar módulo de boletos' }}
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="busy" @click="carregar">Atualizar estado</button>
    </div>
    <form v-if="alvo !== null && podeAlterarModulo" class="border rounded p-3 mt-3" aria-label="Confirmação do módulo de boletos" @submit.prevent="salvar">
      <h6>{{ alvo ? 'Confirmar ativação' : 'Confirmar desativação' }}</h6>
      <p>Esta mudança vale somente para a escola atual. As permissões de usuário, contas financeiras e configurações bancárias continuam sendo verificadas.</p>
      <p v-if="!alvo">Novas operações bancárias serão bloqueadas. Jobs existentes serão preservados e o processamento de confirmações e liquidações pendentes poderá ficar pausado até uma reativação autorizada. Cobranças e pagamentos não serão cancelados ou alterados.</p>
      <p v-else>Ativar o módulo não emite cobranças, não habilita contas financeiras e não ativa configurações bancárias.</p>
      <label for="confirmacao-boletos" class="form-label">Digite exatamente a confirmação fornecida pelo servidor:</label>
      <p class="text-break"><code>{{ frase }}</code></p>
      <input id="confirmacao-boletos" v-model="confirmacao" class="form-control mb-3" autocomplete="off" spellcheck="false" :disabled="busy" />
      <div class="d-flex gap-2 flex-wrap">
        <button type="submit" class="btn btn-sm btn-primary" :disabled="!podeConfirmar">{{ busy ? 'Confirmando…' : 'Confirmar alteração' }}</button>
        <button type="button" class="btn btn-sm btn-secondary" :disabled="busy" @click="fechar">Cancelar alteração</button>
      </div>
    </form>
    </div>
  </FormSection>
</template>
<script>
import FormSection from '@/components/Layout/FormSection.vue';
import { watch } from 'vue';
import axios from '@/services/axios';
import { useBoletosModuloControl } from '@/composables/useBoletosModuloControl';
export default {
  components: { FormSection },
  props: { podeAlterarModulo: { type: Boolean, default: false } },
  setup(props) {
    const control = useBoletosModuloControl(axios, () => props.podeAlterarModulo);
    watch(() => props.podeAlterarModulo, () => control.carregar(), { immediate: true });
    return control;
  }
};
</script>

<style scoped>
.boletos-modulo { min-width: 0; }
.modulo-conteudo { font-size: 0.8rem; overflow-wrap: anywhere; }
.modulo-conteudo h6 { font-size: 0.8rem; font-weight: 600; }
.modulo-conteudo p { margin-bottom: 0.6rem; }
.modulo-conteudo .btn { font-size: 0.75rem; white-space: normal; }
</style>
